<template>
	<el-card v-show="events.length > 0">
		<div slot="header" class="lifestyle header">
			<img src="../image/lifestyle_new.png" class="header-icon">
			<span class="header-title">Lifestyle</span>
		</div>
		<LifestyleTable :patient="patient"
			v-bind:food="food"
			v-bind:water="water"
			v-bind:excretion="excretion">
		</LifestyleTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import LifestyleTable from './Table'

export default {
	name: 'patient-lifestyle-card',
	extends: OverviewCard,

	computed: {
		// Return food, water, and excretion events
		events() {
			return this.food
				.concat(this.water)
				.concat(this.excretion)
		},
		food() {
			return this.patientEventType('food')
		},
		water() {
			return this.patientEventType('water')
		},
		excretion() {
			return this.patientEventType('excretion')
		}
	},

	components: {
		LifestyleTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
@import "./style.scss";
</style>
